import React, { useState } from "react";
import Autosuggest from 'react-autosuggest';
import Select from "react-select";
import { Button, Form } from "react-bootstrap";

const CustomerFilter = (props) => {

  const {
    customers,
    handle
  } = props;

  const [customerValue, setCustomerValue]         = useState('');
  const [suggestions, setSuggestions]             = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);

  // Collage d'une liste d'emails (import en masse)
  const [emailsInput, setEmailsInput] = useState('');
  const [emailsResult, setEmailsResult] = useState(null);

  /**
   * Fonction qui recherche parmis la liste des clients
   */
  const getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    let returnCustomers = [];

    if (inputLength !== 0) {
      returnCustomers = customers.filter((customer) => {
        // Isole chaque string apres un espace
        let values = inputValue.split(" ");
        let customerOk = true;
        if (values.length > 0) {
          values.forEach((v) => {
            if (!customer.lastname.toLowerCase().includes(v.toLowerCase()) && !customer.email.toLowerCase().includes(v.toLowerCase()) && !customer.firstname.toLowerCase().includes(v.toLowerCase())) {
              customerOk = false;
            }
          });
        }
        return customerOk;
      });
    }

    return returnCustomers;
  }

  const getSuggestionValue = suggestion => suggestion.lastname+' '+suggestion.firstname;

  // Use your imagination to render suggestions.
  const renderSuggestion = suggestion => (
    <div>
      {suggestion.lastname+' '+suggestion.firstname+' - '+suggestion.email}
    </div>
  );

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const toOption = (customer) => ({
    label: customer.lastname+' '+customer.firstname+' - '+customer.email,
    value: customer.id
  });

  // Ajoute le client choisi
  const onSuggestionSelected = (event, {suggestion}) => {
    let sc = [...selectedCustomers, toOption(suggestion)];
    setSelectedCustomers(sc);
    handle('customers', sc);
    setCustomerValue('');
  }

  const handleChange = (v) => {
    setSelectedCustomers(v);
    handle('customers', v);
    setCustomerValue('');
  }

  /**
   * Extrait les emails d'un texte collé : séparateurs virgule, point-virgule,
   * espace ou retour à la ligne. Gère aussi le format "Nom <mail@dom.fr>".
   */
  const parseEmails = (text) => {
    const found = String(text || '').match(/[^\s,;<>()[\]"]+@[^\s,;<>()[\]"]+/g) || [];
    const emails = [];
    found.forEach((e) => {
      // Retire une éventuelle ponctuation finale (ex: "mail@dom.fr.")
      const clean = e.trim().toLowerCase().replace(/[.,;]+$/, '');
      if (clean && !emails.includes(clean)) {
        emails.push(clean);
      }
    });
    return emails;
  }

  /**
   * Recherche les clients correspondant aux emails collés et les ajoute
   * à la sélection (sans doublon).
   */
  const addCustomersFromEmails = () => {
    const emails = parseEmails(emailsInput);

    if (emails.length === 0) {
      setEmailsResult({ added: 0, already: 0, notFound: [], invalid: true });
      return;
    }

    const alreadySelectedIds = selectedCustomers.map((c) => String(c.value));
    const newOptions = [];
    const notFound = [];
    let already = 0;

    emails.forEach((email) => {
      const customer = customers.find((c) => c.email && c.email.trim().toLowerCase() === email);
      if (!customer) {
        notFound.push(email);
        return;
      }
      if (alreadySelectedIds.includes(String(customer.id)) || newOptions.some((o) => String(o.value) === String(customer.id))) {
        already++;
        return;
      }
      newOptions.push(toOption(customer));
    });

    if (newOptions.length > 0) {
      const sc = [...selectedCustomers, ...newOptions];
      setSelectedCustomers(sc);
      handle('customers', sc);
    }

    setEmailsResult({ added: newOptions.length, already, notFound, invalid: false });
    if (notFound.length === 0) {
      setEmailsInput('');
    }
  }

  const clearEmails = () => {
    setEmailsInput('');
    setEmailsResult(null);
  }

  return (
    <>
      <div className="mb-2">
        <Select
          isMulti
          onChange={(v) => handleChange(v === null ? [] : v)}
          defaultValue={null}
          value={selectedCustomers}
          options={selectedCustomers}
          placeholder="Choisir les clients..."
        />
      </div>
      <Autosuggest
        className="form-control"
        suggestions={suggestions.slice(0, 10)}
        onSuggestionSelected={onSuggestionSelected}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        highlightFirstSuggestion={true}
        multipleSele
        inputProps={{
         value: customerValue,
         placeholder: 'ou renseigner nom du client (à sélectionner dans la liste des suggestions)',
         onChange: (e, { newValue }) => setCustomerValue(newValue),
       }}

      />

      <hr className="my-3" />

      <div>
        <small className="text-muted d-block mb-1">
          ou coller une liste d'emails (séparés par virgule, point-virgule ou retour à la ligne)
        </small>
        <Form.Control
          as="textarea"
          rows={3}
          value={emailsInput}
          onChange={(e) => setEmailsInput(e.target.value)}
          placeholder="client1@mail.fr, client2@mail.fr&#10;client3@mail.fr"
        />
        <div className="d-flex align-items-center mt-2" style={{ gap: '8px' }}>
          <Button size="sm" variant="success" onClick={addCustomersFromEmails} disabled={emailsInput.trim().length === 0}>
            Ajouter les clients
          </Button>
          {emailsInput.trim().length > 0 &&
            <Button size="sm" variant="link" className="text-muted p-0" onClick={clearEmails}>
              Vider
            </Button>
          }
        </div>
        {emailsResult &&
          <div className="mt-2">
            {emailsResult.invalid &&
              <small className="text-danger d-block">Aucun email détecté dans le texte collé.</small>
            }
            {!emailsResult.invalid &&
              <small className={emailsResult.added > 0 ? "text-success d-block" : "text-muted d-block"}>
                {emailsResult.added} client(s) ajouté(s)
                {emailsResult.already > 0 && `, ${emailsResult.already} déjà sélectionné(s)`}
              </small>
            }
            {emailsResult.notFound.length > 0 &&
              <small className="text-danger d-block">
                {emailsResult.notFound.length} email(s) sans client correspondant : {emailsResult.notFound.join(', ')}
              </small>
            }
          </div>
        }
      </div>
    </>
  );
};

CustomerFilter.propTypes = {

};

export default CustomerFilter;
